export const FLAG_AMPLITUDE_INIT = 'amplitude_init';
export const CHANGE_PAYMENT_TYPE_IN_ORDER = 'change_payment_type_in_order';
export const OWN_PRODUCTS_SET_GLOBUS = 'own_products_set_globus';
export const REDESIGNED_FOOTER = 'redesigned_footer';
export const REDESIGNED_FOOTER_WITH_BTN = 'redesigned_footer_with_btn';
export const NEW_LANDING = 'new_landing';
export const NEW_LANDING_AA = 'new_landing_aa';
export const DELIVERY_PRICE_EXPERIMENT = 'delivery_price_experiment';
